import { createFileRoute } from '@tanstack/react-router';
import { requireProjectsFeature } from '@/features/projects/guard';
import { ProjectList } from '@/features/projects/project-list';
import { parseProjectListSearch } from '@/features/projects/project-list-search';

/** PROJ-05: project overview; archive switch, view (tiles or list) and filters in the URL. */
export const Route = createFileRoute('/_app/projects')({
  validateSearch: (raw: Record<string, unknown>) => parseProjectListSearch(raw),
  beforeLoad: ({ context }) => requireProjectsFeature(context.queryClient),
  component: ProjectsPage,
});

function ProjectsPage() {
  const { me } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProjectList
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: next, replace: true });
      }}
      canCreate={me.globalPermissions.includes('project.create')}
      me={{ id: me.user.id, name: me.user.name }}
    />
  );
}
